<template>
  <div
    class="cate-header-wrapper"
    :class="{
      'trans-open': transOpen,
      'trans-show': transShow,
      'pos-sticky': posSticky,
    }"
  >
    <span class="back" v-if="!iconShow"></span>
    <span class="back" v-else @click="goBack"><i :class="iconClass"></i></span>
    <h1 class="title" v-text="title"></h1>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'PageMbHeader',
  props: {
    iconClass: {
      type: String,
      default: 'icon-linetype_back_iOS',
    },
    title: String,
    posSticky: Boolean,
    transShow: Boolean,
    transOpen: Boolean,
    iconShow: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    goBack() {
      this.$emit('icon-click');
    },
  },
};
</script>

<style lang="scss" scoped src="./index.scss"></style>